var styles = ["[_nghost-%COMP%]     router-outlet+*{display:block;animation:1s fade}@keyframes fade{from{opacity:0}to{opacity:1}}"];
export { styles as styles };
